/**
 * Inline token renderer.
 * Handles: strong, em, codespan, link, image, del, br, text, escape, html.
 * Recursively renders nested inline tokens (bold inside italic, etc).
 */
import React from 'react';
import { decode } from 'html-entities';

const MarkdownInlineTokens = ({ tokens = [] }) => {
  if (!tokens || tokens.length === 0) return null;

  return tokens.map((token, idx) => {
    switch (token.type) {
      case 'strong':
        return (
          <strong key={idx}>
            <MarkdownInlineTokens tokens={token.tokens} />
          </strong>
        );

      case 'em':
        return (
          <em key={idx}>
            <MarkdownInlineTokens tokens={token.tokens} />
          </em>
        );

      case 'codespan':
        return <code key={idx} className="md-inline-code">{token.text}</code>;

      case 'link':
        return (
          <a key={idx} href={token.href} target="_blank" rel="noopener noreferrer" title={token.title || undefined}>
            {token.tokens ? (
              <MarkdownInlineTokens tokens={token.tokens} />
            ) : (
              token.text
            )}
          </a>
        );

      case 'image':
        return <img key={idx} src={token.href} alt={token.text} title={token.title || undefined} />;

      case 'del':
        return (
          <del key={idx}>
            <MarkdownInlineTokens tokens={token.tokens} />
          </del>
        );

      case 'br':
        return <br key={idx} />;

      case 'escape':
        return <React.Fragment key={idx}>{decode(token.text)}</React.Fragment>;

      case 'html':
        return <span key={idx} dangerouslySetInnerHTML={{ __html: token.text }} />;

      case 'text':
        return <React.Fragment key={idx}>{decode(token.text)}</React.Fragment>;

      default:
        return <React.Fragment key={idx}>{decode(token.raw || '')}</React.Fragment>;
    }
  });
};

export default MarkdownInlineTokens;
